import { combineReducers } from 'redux';
import { FETCH_DETAILS, FETCH_SHORT_DETAILS_SUCCEEDED, UPDATE_NAME } from '../actions/ActionTypes';
export const initialShortState = {
  name: '',
  screenshotUrl: '',
  campaignId: '',
  state: 'DRAFT',
  createdAt: -1,
  contentId: -1,
  publishDate: null,
  publishedAt: null,
  containerType: 'MODAL',
  updatedAt: -1,
  updatedById: -1,
  id: -1,
  isActiveAbTest: false
};
const shortDetailsReducer = (state = initialShortState, action) => {
  switch (action.type) {
    case FETCH_SHORT_DETAILS_SUCCEEDED:
      return action.response;
    case UPDATE_NAME:
      return Object.assign({}, state, {
        name: action.name
      });
    default:
      return state;
  }
};
const fullDetailsReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_DETAILS.SUCCEEDED:
      return action.payload;
    default:
      return state;
  }
};
export default combineReducers({
  short: shortDetailsReducer,
  full: fullDetailsReducer
});